export const GROUP_CHAT_REFETCH_INTERVAL = 3000;
